










 

 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamInvitationDialog_verifiedInvitation",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationErrorAccepted_verifiedInvitation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationErrorExpired_verifiedInvitation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationGoogleSignin_verifiedInvitation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationGoogleCreateAccount_verifiedInvitation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationEmailSignin_verifiedInvitation"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInvitationEmailCreateAccount_verifiedInvitation"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGoogle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ssoURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preferredName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VerifiedInvitationPayload",
  "abstractKey": null
};

(node ).hash = "20657be11c46d91549e7093868baf15a";

export default node;
